import React from "react";
import { Button } from "../VFX-UI";
import useButtonStyles from "./styles";

const ClearButton = ({
  onClickHandler,
}: {
  onClickHandler: React.MouseEventHandler<HTMLButtonElement>;
}) => {
  const buttonStyles = useButtonStyles();
  return (
    <Button style={buttonStyles.searchButton} onClick={onClickHandler}>
      Clear
    </Button>
  );
};

export default ClearButton;
